module.exports = __webpack_public_path__ + "media/images/soar/faq_page_figure1-4555e09c35f393804dc008fdbe0e09ab.png";